import { ContactType } from '@lmt/shared-types';
import {
  getContactFieldValue,
  getPriorityContactFieldValue,
  getPriorityContactType,
} from '@lmt/unicorn-shared/app/components/patients/patient-form/common/common';
import { PatientData } from '@lmt/unicorn-shared/app/components/patients/patient-form/common/types';
import { validateAndDirty } from '@lmt/unicorn-shared/app/helpers/form-helper';
import { useEffect } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';

export const UpdateContactWhenFieldsChange: React.FC<{
  form: UseFormReturn<PatientData>;
}> = (props) => {
  const form = props.form;
  const watch = useWatch({
    control: form.control,
    name: [
      'email',
      'homePhone',
      'workPhone',
      'mobilePhone',
      'fax',
      'priorityContactType',
    ],
  });

  useEffect(() => {
    const values = form.getValues();
    const newValue = getContactFieldValue(values);
    props.form.setValue('contact', newValue ?? '', validateAndDirty);

    const priorityContactValue = getPriorityContactFieldValue(values) ?? '';

    if (!!values.priorityContactType && !priorityContactValue) {
      props.form.setValue(
        'priorityContactType',
        ContactType.Undefined,
        validateAndDirty,
      );
    }

    if (!values.priorityContactType && newValue) {
      const priorityContactType = getPriorityContactType(values);
      if (priorityContactType) {
        props.form.setValue(
          'priorityContactType',
          priorityContactType,
          validateAndDirty,
        );
      }
    }
    if (!!priorityContactValue !== !!values.priorityContact) {
      props.form.setValue(
        'priorityContact',
        priorityContactValue,
        validateAndDirty,
      );
    }
  }, [watch]);

  return null;
};
